const labData = [
  {
    name: "id",
    type: "serial",
  },
  {
    name: "labName",
    type: "text",
  },
  {
    name: "labShortName",
    type: "text",
  },
  {
    name: "category",
    type: "text",
  },
  {
    name: "thumbnailImageURL",
    type: "text",
  },
  {
    name: "shortDescription",
    type: "text",
  },
  {
    name: "fullDescription",
    type: "text",
  },
  {
    name: "learningObjectives",
    type: "text",
  },
  {
    name: "authors",
    type: "text",
  },
  {
    name: "labURL",
    type: "text",
  },
  {
    name: "copyrightAttributes",
    type: "text",
  },
  {
    name: "about",
    type: "text",
  },
  {
    name: "reading",
    type: "json",
  },
  {
    name: "reinforcement",
    type: "json",
  },
  {
    name: "quiz",
    type: "json",
  },
  {
    name: "difficulty",
    type: "integer",
  },
  {
    name: "slideshow",
    type: "text",
  },
  {
    name: "walkthroughVideo",
    type: "text",
  },
  {
    name: "isActive",
    type: "boolean default false",
  },
];

export { labData };
